<template>
	<!-- 系统目录 卫材 -->
	<div class="box">
		<!-- main -->
		<div class="main">
			<!-- left -->
			<div class="main-left">
				<!-- 树菜单标题 -->
				<div class="tree-header">
					<span style="font-size: 14px; font-weight: bold; color: #333;">人员积分统计</span>
					<!-- 新增积分分类按钮 -->
					<el-tooltip effect="dark" content="新建积分分类" placement="right">
						<el-button type="text" size="mini" @click="handleAddCategory"
							style="margin-left: 8px; color: #409EFF;">
							<i class="el-icon-adds" style="font-size: 28px;"></i>
						</el-button>
					</el-tooltip>
				</div>

				<!-- tree -->
				<el-tree :data="elTree" v-loading="loading" :element-loading-text="'加载中...'" :props="defaultProps"
					node-key="id" :default-expanded-keys="defaultExpandedKeys" accordion @node-click="handleNodeClick"
					class="custom-tree" :highlight-current="true" :current-node-key="currentTreeNodeKey"
					:expand-on-click-node="false" @node-contextmenu="handleTreeNodeContextMenu" :disabled="false">
					<span class="custom-tree-node" slot-scope="{ node, data }" style="font-size: 12px;">
						<span :name="node.label">
							<!-- 添加状态标识 -->
							<span v-if="!data.children" class="node-status" :style="{ 
				              color: data.state === 1 ? '#67C23A' : '#F56C6C',
				              marginRight: '5px',
				              fontSize: '12px'
				            }">
								<i v-if="data.state === 1" class="el-icon-finishedFill"></i>
								<i v-else class="el-icon-close"></i>
							</span>
							<!-- 修改图标 -->
							<i v-if="!data.children" class="el-icon-menzhen"></i>
							<i v-else class="el-icon-ggml" :style="{fontSize: '14px'}"></i>
							{{ node.label }}
						</span>
					</span>
				</el-tree>

				<!-- 树菜单右键菜单 -->
				<div v-if="treeContextMenu.visible" :style="{
						position: 'fixed',
						left: treeContextMenu.x + 'px',
						top: treeContextMenu.y + 'px',
						zIndex: 9999
					  }" class="tree-context-menu">
					<el-card shadow="always" style="width: 90px;">
						<!-- 父节点菜单 -->
						<div v-if="treeContextMenu.type === 'parent'">
							<el-button type="text" size="mini" @click="handleAddCategoryFromContext"
								style="width: 100%; text-align: left;">
								<i class="el-icon-plus"></i> 添加分类
							</el-button>
							<el-button type="text" size="mini" @click="refreshPersonPointsData"
								style="width: 100%; text-align: left;">
								<i class="el-icon-refresh"></i> 更新数据
							</el-button>
							<el-button type="text" size="mini" @click="goToPersonPointsTable"
								style="width: 100%; text-align: left;">
								<i class="el-icon-s-grid"></i> 统计信息
							</el-button>
						</div>
						<!-- 子节点菜单 -->
						<div v-else-if="treeContextMenu.type === 'child'">
							<!-- 启用/禁用选项 -->
							<el-button v-if="treeContextMenu.data.state === 0" type="text" size="mini"
								@click="toggleCategoryStatus" style="width: 100%; text-align: left;">
								<i class="el-icon-myyzy"></i> 启用
							</el-button>
							<el-button v-else type="text" size="mini" @click="toggleCategoryStatus"
								style="width: 100%; text-align: left;">
								<i class="el-icon-lszt"></i> 禁用
							</el-button>

							<!-- 修改分类选项，禁用状态下不可用 -->
							<el-button type="text" size="mini" @click="editCategoryInfoFromContext"
								style="width: 100%; text-align: left;" :disabled="treeContextMenu.data.state === 0"
								:title="treeContextMenu.data.state === 0 ? '分类已禁用，不可修改' : ''">
								<i class="el-icon-edit"></i> 修改
							</el-button>

							<!-- 分类详情选项，禁用状态下不可用 -->
							<el-button type="text" size="mini" @click="showCategoryDetail"
								style="width: 100%; text-align: left;" :disabled="treeContextMenu.data.state === 0"
								:title="treeContextMenu.data.state === 0 ? '分类已禁用，不可查看' : ''">
								<i class="el-icon-tnzdsj"></i> 详情
							</el-button>

							<!-- 添加规则选项，禁用状态下不可用 -->
							<el-button type="text" size="mini" @click="goToCategoryTable"
								style="width: 100%; text-align: left;" :disabled="treeContextMenu.data.state === 0"
								:title="treeContextMenu.data.state === 0 ? '分类已禁用，不可添加规则' : ''">
								<i class="el-icon-adds"></i> 添加规则
							</el-button>
						</div>
					</el-card>
				</div>
			</div>

			<!-- right -->
			<div class="main-right" ref="mainRight">
				<!-- 面包屑导航 -->
				<div class="breadcrumb-section">
					<el-breadcrumb separator="/" style="font-size: 12px;">
						<el-breadcrumb-item v-for="(item, index) in breadcrumbItems" :key="index" :to="item.to"
							:class="{'breadcrumb-active': index === breadcrumbItems.length - 1}">
							<span v-if="item.clickable" @click="handleBreadcrumbClick(item)" style="cursor: pointer;">
								{{ item.name }}
							</span>
							<span v-else>
								{{ item.name }}
							</span>
						</el-breadcrumb-item>
					</el-breadcrumb>
				</div>

				<!-- 搜索和操作区域 -->
				<div class="main-icon" v-if="isPersonPointsMode">
					<div class="main-icon-a">
						<i :class="iconComes"
							style="border-radius: 50%;font-size: 20px;padding: 6px;margin-left: 8px;background-color: #00557f;color: #fff;"></i>
						<span style="font-size: 12px;font-weight:bold;margin-left: 12px;color: #606266;">
							{{ CatalogueName }}
						</span>
					</div>

					<!-- 关键字搜索 -->
					<div class="main-icon-c">
						<span
							style="font-size: 12px;color: #606266;font-weight: bold;display: inline-block;width: 68px;">
							关键字：
						</span>
						<el-input size="mini" placeholder="请输入姓名" v-model="searchValue"
							@keyup.enter.native="handleSearch">
							<i slot="suffix" class="el-input__icon el-icon-Ssearch" style="cursor: pointer;"
								@click="handleSearch"></i>
						</el-input>
					</div>

					<!-- btn3 -->
					<div class="main-icon-c">
						<el-button v-for="(v, i) in headerBtn" :key="i" :type="v.type" :loading="loading" :icon="v.icon"
							size="mini" @click="handClick(i)">
							{{ v.title }}
						</el-button>
					</div>
				</div>

				<!-- 分类节点表格头部 -->
				<div v-if="!isPersonPointsMode" class="category-header">
					<div class="category-title">
						<span style="font-size: 16px; font-weight: bold; color: #333;">
							{{ categoryTitle }}
						</span>
						<!-- 添加规则按钮 -->
						<el-button v-if="!isAddingRule" type="primary" size="mini" icon="el-icon-plus"
							@click="handleAddRule" style="margin-left: 12px;">
							添加规则
						</el-button>
						<!-- 分类详情按钮 -->
						<el-button type="info" size="mini" icon="el-icon-document" @click="showCategoryDetailFromHeader"
							style="margin-left: 8px;">
							分类详情
						</el-button>
						<!-- 修改分类信息按钮 -->
						<el-button type="warning" size="mini" icon="el-icon-edit" @click="editCategoryInfoFromHeader"
							style="margin-left: 8px;">
							修改分类信息
						</el-button>
					</div>
				</div>

				<!-- table -->
				<div class="table-container">
					<div class="table-wrapper">
						<!-- table -->
						<el-table :data="tableData" border @row-dblclick="handledbRow" @row-click="handleRowClick"
							@row-mouse-enter="handleRowMouseEnter" @row-mouse-leave="handleRowMouseLeave"
							element-loading-text="查询中" element-loading-spinner="el-icon-more-outline"
							highlight-current-row ref="singleTable" style="width: 100%" height="calc(100vh - 320px)"
							v-loading="tableLoading" :empty-text="customEmptyText" :row-class-name="tableRowClassName">
							<el-table-column fixed="left" label="行号" type="index" width="50"
								align="center"></el-table-column>

							<!-- 状态列（仅在分类节点模式显示） -->
							<el-table-column v-if="!isPersonPointsMode" label="状态" width="80" align="center"
								fixed="left">
								<template slot-scope="scope">
									<el-switch v-model="scope.row.state" :active-value="1" :inactive-value="0"
										active-color="#13ce66" inactive-color="#ff4949"
										@change="handleStateChange(scope.row)" :loading="scope.row.stateLoading"
										:disabled="scope.row.isNew || scope.row.isEditing"></el-switch>
								</template>
							</el-table-column>

							<!-- 动态生成列 -->
							<template v-for="(col, inx) in currentTableColumns">
								<el-table-column :key="inx" :type="col.typed" :prop="col.prop" :label="col.name"
									:width="columnWidth(col, tableData)" :show-overflow-tooltip="true" align="center"
									header-align="center">
									<!-- 人员所属分类列的特殊处理 -->
									<template v-if="col.prop === 'pointPhrTypeName' && isPersonPointsMode"
										v-slot="scope">
										<div v-if="scope.row.isEditing">
											<el-select v-model="scope.row.editingPointPhrTypeId" placeholder="请选择积分分类"
												size="mini" style="width: 100%">
												<el-option v-for="item in pointTypeSelectOptions" :key="item.value"
													:label="getCategoryOptionLabel(item)" :value="item.value"
													:disabled="item.disabled || false"
													:title="getCategoryOptionTitle(item)">
													<!-- 自定义选项内容，显示状态标签 -->
													<span
														:class="{'disabled-option': item.disabled}">{{ item.label }}</span>
													<i class="el-icon-close" v-if="item.disabled"
														style="color: #F56C6C;"></i>
													<i class="el-icon-guahao" v-else style="color: #67C23A;"></i>
												</el-option>
											</el-select>
										</div>
										<div v-else>
											<span>{{ scope.row[col.prop] || '未分类' }}</span>
										</div>
									</template>

									<!-- 积分数量列的特殊处理 -->
									<template v-else-if="col.prop === 'pointNum' && isPersonPointsMode" v-slot="scope">
										<span class="point-num-highlight">{{ scope.row[col.prop] }}</span>
									</template>

									<!-- 性别列的特殊处理 -->
									<template v-else-if="col.prop === 'sex' && isPersonPointsMode" v-slot="scope">
										<span>{{ sexFormatter(scope.row, col, scope.row[col.prop]) }}</span>
									</template>

									<!-- 分类节点模式下的特殊处理 -->
									<template v-else-if="!isPersonPointsMode" v-slot="scope">
										<!-- 新增规则行的可编辑字段 -->
										<template v-if="scope.row.isNew">
											<template v-if="col.prop === 'pointPhrTypeName'">
												<el-input v-model="newRule.pointPhrTypeName" size="mini"
													:placeholder="currentTreeNode ? currentTreeNode.label : '积分人员分类'"
													style="width: 100%" :disabled="true" />
											</template>
											<template v-else-if="col.prop === 'pointPricStart'">
												<el-input-number v-model="newRule.pointPricStart" :min="0"
													:precision="0" controls-position="right" placeholder="消费金额下限"
													size="mini" style="width: 100%" />
											</template>
											<template v-else-if="col.prop === 'pointPricEnd'">
												<el-input-number v-model="newRule.pointPricEnd"
													:min="newRule.pointPricStart || 0" :precision="0"
													controls-position="right" placeholder="消费金额上限" size="mini"
													style="width: 100%" />
											</template>
											<template v-else-if="col.prop === 'pointSalePric'">
												<el-input-number v-model="newRule.pointSalePric" :min="0" :precision="0"
													controls-position="right" placeholder="生成1积分所需金额" size="mini"
													style="width: 100%" />
											</template>
											<template v-else-if="col.prop === 'remark'">
												<el-input v-model="newRule.remark" size="mini"
													placeholder="请输入备注（最多20个字）" maxlength="20" show-word-limit
													style="width: 100%" />
											</template>
											<template v-else-if="col.prop === 'state'">
												<!-- 状态已在状态列中显示 -->
											</template>
											<template
												v-else-if="col.prop === 'createName' || col.prop === 'createTime'">
												<!-- 新增行不显示创建人和创建时间 -->
												<span>-</span>
											</template>
											<template v-else>
												<span>{{ scope.row[col.prop] }}</span>
											</template>
										</template>
										<!-- 编辑状态下的可编辑字段 -->
										<template v-else-if="scope.row.isEditing">
											<!-- 积分人员分类名称列 -->
											<template v-if="col.prop === 'pointPhrTypeName'">
												<!-- 人员积分统计模式 -->
												<div v-if="isPersonPointsMode">
													<div v-if="scope.row.isEditing">
														<el-select v-model="scope.row.editingPointPhrTypeId"
															placeholder="请选择积分分类" size="mini" style="width: 100%"
															@change="handleEditingPointTypeChange(scope.row)">
															<el-option v-for="item in pointTypeSelectOptions"
																:key="item.value" :label="getCategoryOptionLabel(item)"
																:value="item.value" :disabled="item.disabled || false"
																:title="getCategoryOptionTitle(item)">
																<span
																	:class="{'disabled-option': item.disabled}">{{ item.label }}</span>
																<span v-if="item.disabled"
																	style="float: right; color: #F56C6C; font-size: 12px;">
																	已禁用
																</span>
																<span v-else
																	style="float: right; color: #67C23A; font-size: 12px;">
																	已启用
																</span>
															</el-option>
														</el-select>
													</div>
													<div v-else>
														<span>{{ scope.row[col.prop] || '未分类' }}</span>
													</div>
												</div>
												<!-- 积分规则模式：编辑时显示固定文本，不可修改 -->
												<div v-else>
													<!-- 编辑状态下显示固定的分类名称，不允许修改 -->
													<span v-if="scope.row.isEditing" class="readonly-field">
														<el-tag type="info" size="mini">
															{{ scope.row[col.prop] || '未分类' }}
														</el-tag>
														<span style="margin-left: 8px; font-size: 12px; color: #999;">
															(当前分类不可修改)
														</span>
													</span>
													<span v-else>
														{{ scope.row[col.prop] || '未分类' }}
													</span>
												</div>
											</template>
											<template v-else-if="col.prop === 'pointPricStart'">
												<el-input-number v-model="scope.row.editingPointPricStart" :min="0"
													:precision="0" controls-position="right" placeholder="消费金额下限"
													size="mini" style="width: 100%" :disabled="scope.row.state === 0" />
											</template>
											<template v-else-if="col.prop === 'pointPricEnd'">
												<el-input-number v-model="scope.row.editingPointPricEnd"
													:min="scope.row.editingPointPricStart || 0" :precision="0"
													controls-position="right" placeholder="消费金额上限" size="mini"
													style="width: 100%" :disabled="scope.row.state === 0" />
											</template>
											<template v-else-if="col.prop === 'pointSalePric'">
												<el-input-number v-model="scope.row.editingPointSalePric" :min="0"
													:precision="0" controls-position="right" placeholder="生成1积分所需金额"
													size="mini" style="width: 100%" :disabled="scope.row.state === 0" />
											</template>
											<template v-else-if="col.prop === 'remark'">
												<el-input v-model="scope.row.editingRemark" size="mini"
													placeholder="请输入备注（最多20个字）" maxlength="20" show-word-limit
													style="width: 100%" :disabled="scope.row.state === 0" />
											</template>
											<template v-else-if="col.prop === 'state'">
												<!-- 状态已在状态列中显示 -->
											</template>
											<template
												v-else-if="col.prop === 'createName' || col.prop === 'createTime'">
												<span>{{ scope.row[col.prop] }}</span>
											</template>
											<template v-else>
												<span>{{ scope.row[col.prop] }}</span>
											</template>
										</template>
										<!-- 非编辑状态下的普通显示 -->
										<template v-else>
											<span>{{ scope.row[col.prop] }}</span>
										</template>
									</template>

									<!-- 默认处理（人员积分统计模式下的普通列） -->
									<template v-else v-slot="scope">
										<span>{{ scope.row[col.prop] }}</span>
									</template>
								</el-table-column>
							</template>

							<!-- 操作列（仅在人员积分统计时显示） -->
							<el-table-column v-if="isPersonPointsMode" fixed="right" label="操作" width="280"
								align="center">
								<template slot-scope="scope">
									<div class="action-buttons"
										style="text-align: center; display: flex; justify-content: center; gap: 4px;">
										<!-- 扣减积分按钮 -->
										<el-button type="danger" @click="handleDeductPoints(scope.row)" size="mini"
											:disabled="scope.row.isEditing || isAnyRowEditing">
											扣减积分
										</el-button>

										<!-- 扣减明细按钮 -->
										<el-button type="info" @click="goToPointsDeductPage" size="mini"
											:disabled="scope.row.isEditing || isAnyRowEditing">
											扣减明细
										</el-button>

										<!-- 明细按钮 -->
										<el-button type="primary" @click="handlePointDetail(scope.row)" size="mini"
											:disabled="scope.row.isEditing || isAnyRowEditing">
											明细
										</el-button>

										<!-- 修改/保存按钮 -->
										<template v-if="scope.row.isEditing">
											<!-- 取消按钮 -->
											<el-button type="default" @click="cancelEdit(scope.row)" size="mini">
												取消
											</el-button>

											<!-- 保存按钮 -->
											<el-button type="success" @click="saveEdit(scope.row)" size="mini"
												:loading="scope.row.saving">
												保存
											</el-button>
										</template>
										<template v-else>
											<!-- 修改按钮 -->
											<el-button type="warning" @click="startEdit(scope.row)" size="mini"
												:disabled="!hasEditPermission || isAnyRowEditing"
												:title="hasEditPermission ? '修改该条数据' : '您当前暂无修改此功能的权限！'">
												修改
											</el-button>
										</template>
									</div>
								</template>
							</el-table-column>

							<!-- 操作列（仅在分类节点模式显示） -->
							<el-table-column v-if="!isPersonPointsMode" fixed="right" label="操作" width="220"
								align="center">
								<template slot-scope="scope">
									<div class="action-buttons"
										style="text-align: center; display: flex; justify-content: center; gap: 4px;">
										<!-- 新增规则行的操作按钮 -->
										<template v-if="scope.row.isNew">
											<!-- 取消按钮 -->
											<el-button type="default" @click="cancelAddRule" size="mini">取消</el-button>
											<!-- 确认添加按钮 -->
											<el-button type="primary" @click="confirmAddRule" size="mini"
												:loading="addRuleLoading">确认添加</el-button>
										</template>
										<!-- 编辑行的操作按钮 -->
										<template v-else-if="scope.row.isEditing">
											<!-- 取消按钮 -->
											<el-button type="default" @click="cancelEditRule(scope.row)"
												size="mini">取消</el-button>
											<!-- 保存按钮 -->
											<el-button type="success" @click="saveEditRule(scope.row)" size="mini"
												:loading="scope.row.saving">保存</el-button>
										</template>
										<!-- 普通行的操作按钮 -->
										<template v-else>
											<!-- 详情按钮 -->
											<el-button type="primary" @click="handleRuleDetail(scope.row)" size="mini">
												详情
											</el-button>

											<!-- 修改按钮 - 禁用状态下不可用 -->
											<el-button type="warning" @click="startEditRule(scope.row)" size="mini"
												:disabled="scope.row.isEditing || isAnyRowEditingRule || scope.row.isNew || scope.row.state === 0"
												:title="scope.row.state === 0 ? '该分类规则目前处于锁定状态！如需对其进行操作，请先去启用该规则！' : ''">
												修改
											</el-button>

											<!-- 删除按钮 - 禁用状态下不可用 -->
											<el-button type="danger" @click="handleDeleteRule(scope.row)" size="mini"
												:disabled="scope.row.state === 0"
												:title="scope.row.state === 0 ? '该分类规则目前处于锁定状态！如需对其进行操作，请先去启用该规则！' : ''">
												删除
											</el-button>
										</template>
									</div>
								</template>
							</el-table-column>
						</el-table>
					</div>

					<!-- 分页（仅在人员积分统计时显示） -->
					<el-pagination v-if="isPersonPointsMode" @size-change="handleSizeChange"
						@current-change="handleCurrentChange" :current-page="pageNum" :page-sizes="[8, 16, 24]"
						:page-size="pageSize" :total="totalSize" layout="total, sizes, prev, pager, next, jumper"
						background style="margin: 12px 0;"></el-pagination>
				</div>
			</div>
		</div>

		<!-- 扣减积分模态框 -->
		<el-dialog :title="deductDialogTitle" :visible.sync="deductDialogVisible" width="500px"
			@close="handleDeductDialogClose" class="custom-dialog deduct-points-dialog">
			<el-form ref="deductForm" :model="deductForm" :rules="deductFormRules" label-width="120px" size="small">
				<el-row :gutter="20">
					<el-col :span="24">
						<el-form-item label="业务来源：" prop="bizSouc" required>
							<el-select v-model="deductForm.bizSouc" placeholder="请选择业务来源" style="width: 100%" clearable>
								<el-option v-for="item in bizSoucOptions" :key="item.value" :label="item.label"
									:value="item.value" />
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="扣减数量：" prop="reduceNum" required>
							<el-input v-model="deductForm.reduceNum" placeholder="请输入大于等于1的正整数" style="width: 100%"
								@input="handleReduceNumInput" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="备注：">
							<el-input v-model="deductForm.remark" placeholder="请输入备注（可选）" style="width: 100%"
								maxlength="100" show-word-limit type="textarea" :rows="3" />
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="deductDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="submitDeductPoints" :loading="deductLoading">确认扣减</el-button>
			</div>
		</el-dialog>

		<!-- 积分变动明细模态框 -->
		<el-dialog :title="`${currentDetailPerson} - 积分变动明细记录`" :visible.sync="detailDialogVisible" width="80%"
			@close="handleDetailDialogClose" class="custom-dialog">
			<!-- 积分变动明细表格 -->
			<div class="detail-table-section">
				<el-table :data="detailData" v-loading="detailLoading" style="width: 100%" height="400px" border stripe>
					<el-table-column type="index" label="序号" width="70" align="center" />
					<el-table-column prop="personName" label="人员名称" min-width="150" show-overflow-tooltip />
					<el-table-column prop="bizSoucName" label="业务来源名称" min-width="150" show-overflow-tooltip />
					<el-table-column prop="pointAgoNum" label="变化前积分数量" min-width="150" align="center">
						<template #default="{ row }">
							<span>{{ row.pointAgoNum }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="pointChgNum" label="积分变化数量" min-width="150" align="center">
						<template #default="{ row }">
							<span :style="{ color: row.pointChgNum >= 0 ? '#F56C6C' : '#67C23A' }">
								{{ row.pointChgNum >= 0 ? '-' + row.pointChgNum : row.pointChgNum }}
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="pointAfrNum" label="变化后积分数量" min-width="150" align="center">
						<template #default="{ row }">
							<span>{{ row.pointAfrNum }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="createName" label="创建人名称" min-width="120" show-overflow-tooltip />
					<el-table-column prop="createTime" label="创建时间" min-width="180" show-overflow-tooltip />
					<el-table-column prop="remark" label="备注" min-width="150" show-overflow-tooltip>
						<template #default="{ row }">
							<span>{{ row.remark || '无' }}</span>
						</template>
					</el-table-column>
				</el-table>
			</div>

			<!-- 积分变动明细分页组件 -->
			<div class="pagination-section" v-if="detailTotal > 0" style="margin-top: 20px">
				<el-pagination background :current-page="detailQueryParams.pageNum"
					:page-size="detailQueryParams.pageSize" :total="detailTotal" :page-sizes="[10, 15, 20, 30, 50]"
					layout="total, sizes, prev, pager, next, jumper" @size-change="handleDetailSizeChange"
					@current-change="handleDetailCurrentChange" />
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="detailDialogVisible = false">关闭</el-button>
			</div>
		</el-dialog>

		<!-- 积分规则详情模态框 -->
		<el-dialog :title="ruleDetailTitle" :visible.sync="ruleDetailDialogVisible" width="600px"
			@close="handleRuleDetailDialogClose" class="custom-dialog">
			<div v-if="currentRuleDetail" class="rule-detail-content">
				<el-descriptions :column="1" border size="small">
					<el-descriptions-item label="积分人员分类">
						{{ currentRuleDetail.pointPhrTypeName || '无' }}
					</el-descriptions-item>
					<el-descriptions-item label="消费金额下限">
						{{ currentRuleDetail.pointPricStart || 0 }}
					</el-descriptions-item>
					<el-descriptions-item label="消费金额上限">
						{{ currentRuleDetail.pointPricEnd || 0 }}
					</el-descriptions-item>
					<el-descriptions-item label="生成1积分所需金额">
						{{ currentRuleDetail.pointSalePric || 0 }}
					</el-descriptions-item>
					<el-descriptions-item label="状态">
						<span :style="{ color: currentRuleDetail.state === 1 ? '#67C23A' : '#F56C6C' }">
							{{ currentRuleDetail.state === 1 ? '已生效' : '未生效' }}
						</span>
					</el-descriptions-item>
					<el-descriptions-item label="创建人">
						{{ currentRuleDetail.createName || '无' }}
					</el-descriptions-item>
					<el-descriptions-item label="创建时间">
						{{ currentRuleDetail.createTime || '无' }}
					</el-descriptions-item>
					<el-descriptions-item label="备注">
						{{ currentRuleDetail.remark || '无' }}
					</el-descriptions-item>
				</el-descriptions>
			</div>
			<div v-else style="text-align: center; padding: 20px;">
				<i class="el-icon-loading" style="font-size: 20px;"></i>
				<p>加载中...</p>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="ruleDetailDialogVisible = false">关闭</el-button>
			</div>
		</el-dialog>

		<!-- 分类详情模态框 -->
		<el-dialog :title="categoryDetailDialogTitle" :visible.sync="categoryDetailDialogVisible" width="900px"
			@close="handleCategoryDetailDialogClose" class="custom-dialog">
			<div v-if="categoryDetailData" class="category-detail-content">
				<el-row :gutter="20">
					<!-- 左侧分类信息 -->
					<el-col :span="12">
						<el-descriptions :column="1" border size="small" title="">
							<el-descriptions-item label="分类名称">
								<el-input v-if="categoryDetailMode === 'edit'" v-model="categoryDetailData.name"
									size="mini" placeholder="请输入分类名称" />
								<span v-else>{{ categoryDetailData.name || '无' }}</span>
							</el-descriptions-item>
							<el-descriptions-item label="生日积分生成倍数">
								<el-input v-if="categoryDetailMode === 'edit'"
									v-model="categoryDetailData.birthPointNum" size="mini" placeholder="请输入生日积分生成倍数" />
								<span v-else>{{ categoryDetailData.birthPointNum || 0 }}</span>
							</el-descriptions-item>
							<el-descriptions-item label="生日积分倍数生效">
								<el-switch v-if="categoryDetailMode === 'edit'" v-model="categoryDetailData.birthState"
									:active-value="1" :inactive-value="0" active-text="是" inactive-text="否"></el-switch>
								<span v-else>
									{{ categoryDetailData.birthState === 1 ? '是' : '否' }}
								</span>
							</el-descriptions-item>
							<el-descriptions-item label="积分规则状态生效">
								<el-switch v-if="categoryDetailMode === 'edit'" v-model="categoryDetailData.ruleState"
									:active-value="1" :inactive-value="0" active-text="是" inactive-text="否"></el-switch>
								<span v-else>
									{{ categoryDetailData.ruleState === 1 ? '是' : '否' }}
								</span>
							</el-descriptions-item>
							<el-descriptions-item label="状态">
								<el-switch v-if="categoryDetailMode === 'edit'" v-model="categoryDetailData.state"
									:active-value="1" :inactive-value="0" active-text="立即生效" inactive-text="不生效"
									active-color="#13ce66" inactive-color="#ff4949"></el-switch>
								<span v-else>
									{{ categoryDetailData.state === 1 ? '立即生效' : '不生效' }}
								</span>
							</el-descriptions-item>
							<el-descriptions-item label="创建人">
								{{ categoryDetailData.createName || '无' }}
							</el-descriptions-item>
							<el-descriptions-item label="创建时间">
								{{ categoryDetailData.createTime || '无' }}
							</el-descriptions-item>
						</el-descriptions>
					</el-col>
					<!-- 右侧规则列表 -->
					<el-col :span="12">
						<div class="category-rule-list">
							<h4 style="margin-bottom: 10px;">积分规则列表</h4>
							<el-table :data="categoryRuleList" border stripe size="mini" height="300"
								style="width: 100%">
								<el-table-column type="index" width="50" align="center" />
								<el-table-column prop="pointPricStart" label="消费金额下限 >=" width="100" align="center" />
								<el-table-column prop="pointPricEnd" label="消费金额上限 <=" width="100" align="center" />
								<el-table-column prop="pointSalePric" label="生成1积分所需金额" width="120" align="center" />
								<el-table-column prop="remark" label="备注" show-overflow-tooltip />
								<el-table-column prop="state" label="状态" width="80" align="center">
									<template #default="{ row }">
										<span :style="{ color: row.state === 1 ? '#67C23A' : '#F56C6C' }">
											{{ row.state === 1 ? '已生效' : '未生效' }}
										</span>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</el-col>
				</el-row>
			</div>
			<div v-else style="text-align: center; padding: 20px;">
				<i class="el-icon-loading" style="font-size: 20px;"></i>
				<p>加载中...</p>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="categoryDetailDialogVisible = false">关闭</el-button>
				<el-button v-if="categoryDetailMode === 'edit'" type="primary" @click="saveCategoryEdit"
					:loading="categoryEditLoading">
					保存修改
				</el-button>
			</div>
		</el-dialog>

		<!-- 新建积分分类模态框 -->
		<el-dialog title="新建积分人员分类" :visible.sync="addCategoryDialogVisible" width="500px"
			@close="handleAddCategoryDialogClose" class="custom-dialog category-create-dialog">
			<el-form ref="addCategoryForm" :model="addCategoryForm" :rules="addCategoryRules" label-width="140px"
				size="small">
				<el-row :gutter="20">
					<el-col :span="24">
						<el-form-item label="分类名称：" prop="name" required>
							<el-input v-model="addCategoryForm.name" placeholder="请输入分类名称" style="width: 100%"
								maxlength="20" show-word-limit />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="生日积分生成倍数：" prop="birthPointNum">
							<el-input v-model="addCategoryForm.birthPointNum" placeholder="请输入大于0的正整数"
								style="width: 100%" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="生日积分倍数生效：" prop="birthState">
							<el-switch v-model="addCategoryForm.birthState" :active-value="1" :inactive-value="0"
								active-text="是" inactive-text="否" style="margin-top: 8px;"></el-switch>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="积分规则状态生效：" prop="ruleState">
							<el-switch v-model="addCategoryForm.ruleState" :active-value="1" :inactive-value="0"
								active-text="是" inactive-text="否" style="margin-top: 8px;"></el-switch>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="状态：" prop="state" required>
							<el-switch v-model="addCategoryForm.state" :active-value="1" :inactive-value="0"
								active-text="立即生效" inactive-text="不生效" style="margin-top: 8px;" active-color="#13ce66"
								inactive-color="#ff4949"></el-switch>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="addCategoryDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="handleSubmitAddCategory" :loading="addCategoryLoading">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	// 人员积分统计
	import {
		pageList,
		chgDetail,
		pointPhrTypeDetail,
		updateType
	} from "@/api/points.js";
	// 分类相关
	import {
		listAll,
		listSelectAll,
		addPhrType,
		editPhrType,
		deletePhrType,
		getPointsDetails
	} from "@/api/points.js";
	// 人员积分规则相关
	import {
		addPointsRule,
		updatePointsRule,
		pointsRuleDetails,
		deleteRule,
		editPointsRule
	} from "@/api/points.js";
	//扣减
	import {
		addReduce,
		reduceList,
		point_souc
	} from "@/api/points.js";
	export default {
		name: 'PointsAccManagement',
		data() {
			// 验证扣减数量
			const validateReduceNum = (rule, value, callback) => {
				if (value === '' || value === null) {
					callback(new Error('请输入扣减数量'));
					return;
				}

				const intValue = parseInt(value);
				if (isNaN(intValue) || !Number.isInteger(parseFloat(value))) {
					callback(new Error('只能输入整数，不能输入小数'));
					return;
				}

				if (intValue < 1) {
					callback(new Error('请输入大于等于1的正整数'));
				} else {
					callback();
				}
			};
			// 验证生日积分生成倍数
			const validateBirthPointNum = (rule, value, callback) => {
				if (value === '' || value === null) {
					callback();
					return;
				}

				// 检查是否为整数
				const intValue = parseInt(value);
				if (isNaN(intValue) || !Number.isInteger(parseFloat(value))) {
					callback(new Error('只能输入大于等于1的正整数，不能输入小数'));
					return;
				}

				// 检查是否大于等于1
				if (intValue < 1) {
					callback(new Error('请输入大于等于1的正整数'));
				} else {
					callback();
				}
			};

			// 验证分类名称
			const validateName = (rule, value, callback) => {
				if (!value || value.trim() === '') {
					callback(new Error('分类名称不能为空！'));
					return;
				}

				// 计算字符长度
				let length = 0;
				for (let i = 0; i < value.length; i++) {
					const charCode = value.charCodeAt(i);
					if (charCode >= 0 && charCode <= 128) {
						length += 1; // 英文字符和特殊字符
					} else {
						length += 2; // 中文字符
					}
				}

				if (length > 20) { // 6个汉字*2 + 8个英文*1 = 20
					callback(new Error('分类名称不能超出（6个汉字，8个英文以及特殊字符）！'));
				} else {
					callback();
				}
			};

			return {
				defaultProps: {
					children: 'children',
					label: 'label',
					disabled: 'disabled' // 添加disabled属性支持
				},
				// 添加disabled属性
				disabled: false,
				// 字符串数据
				windowWidth: '',
				searchValue: '',
				iconComes: 'el-icon-charging',
				CatalogueName: '人员积分统计',
				DropDownedName: '可用',
				operatingTime: '',
				categoryTitle: '', // 分类节点标题
				ruleDetailTitle: '', // 规则详情标题
				customEmptyText: '', // 自定义空状态文本
				categoryDetailDialogTitle: '', // 分类详情对话框标题
				categoryDetailMode: 'view', // 分类详情模式：view/edit

				// 业务数据
				eisaiTypeCode: '',
				state: '',
				dialogMode: 'add',
				currentTreeNodeKey: '', // 当前选中的树节点key
				currentTreeNode: null, // 当前选中的树节点数据
				defaultExpandedKeys: [], // 默认展开的节点

				// 面包屑导航
				breadcrumbItems: [{
					name: '人员积分统计',
					id: 'person_points',
					clickable: false
				}],

				// 布尔值
				loading: false,
				tableLoading: false,
				isPersonPointsMode: true, // 是否为人员积分统计模式
				isAddingRule: false, // 是否正在添加规则
				addRuleLoading: false, // 添加规则加载状态
				addCategoryDialogVisible: false, // 添加分类对话框
				addCategoryLoading: false, // 添加分类加载状态
				categoryDetailDialogVisible: false, // 分类详情对话框
				categoryEditLoading: false, // 分类编辑加载状态

				// 树菜单右键菜单
				treeContextMenu: {
					visible: false,
					x: 0,
					y: 0,
					type: '', // parent/child
					data: null
				},

				// 积分分类下拉选项
				pointTypeSelectOptions: [],

				// 数字
				pageNum: 1,
				pageSize: 8,
				totalSize: 0,

				// 对象
				addForm: {},
				currentTable: {},
				newRule: { // 新增规则表单
					pointPhrTypeName: '',
					pointPricStart: null,
					pointPricEnd: null,
					pointSalePric: 0,
					remark: '',
					state: 1
				},
				addCategoryForm: { // 新增分类表单
					name: '',
					birthPointNum: 0,
					birthState: 1, // 默认生效
					ruleState: 1, // 默认生效
					state: 1 // 默认立即生效
				},
				addCategoryRules: { // 新增分类验证规则
					name: [{
						required: true,
						validator: validateName,
						trigger: 'blur'
					}],
					birthPointNum: [{
						validator: validateBirthPointNum,
						trigger: 'blur'
					}]
				},
				// 扣减积分相关数据
				deductDialogVisible: false,
				deductDialogTitle: '',
				currentDeductPerson: null,
				deductForm: {
					bizSouc: null,
					phrClinicId: null,
					reduceNum: 1,
					remark: ''
				},
				deductFormRules: {
					bizSouc: [{
						required: true,
						message: '请选择业务来源',
						trigger: 'change'
					}],
					reduceNum: [{
						required: true,
						validator: validateReduceNum,
						trigger: 'blur'
					}]
				},
				bizSoucOptions: [], // 业务来源下拉选项
				deductLoading: false,
				// 分类详情数据
				categoryDetailData: null,
				categoryRuleList: [],

				// 积分规则详情相关
				ruleDetailDialogVisible: false,
				currentRuleDetail: null,

				// 数组
				tableData: [],
				userInfo: [],
				elTree: [{
					label: '人员积分统计',
					id: 'person_points',
					children: []
				}],

				// 表格列配置
				personPointsColumns: [{
						name: "姓名",
						prop: "personName",
						typed: ""
					},
					{
						name: "性别",
						prop: "sex",
						typed: ""
					},
					{
						name: "人员所属分类",
						prop: "pointPhrTypeName",
						typed: ""
					},
					{
						name: "健康卡号",
						prop: "patId",
						typed: ""
					},
					{
						name: "证件号码",
						prop: "certNo",
						typed: ""
					},
					{
						name: "积分数量",
						prop: "pointNum",
						typed: ""
					},
					{
						name: "联系电话",
						prop: "tel",
						typed: ""
					}
				],

				pointRuleColumns: [{
						name: "积分人员分类",
						prop: "pointPhrTypeName",
						typed: ""
					},
					{
						name: "消费金额下限>=",
						prop: "pointPricStart",
						typed: ""
					},
					{
						name: "消费金额上限<=",
						prop: "pointPricEnd",
						typed: ""
					},
					{
						name: "生成1积分所需金额",
						prop: "pointSalePric",
						typed: ""
					},
					{
						name: "备注",
						prop: "remark",
						typed: ""
					},
					{
						name: "创建人",
						prop: "createName",
						typed: ""
					},
					{
						name: "创建时间",
						prop: "createTime",
						typed: ""
					}
				],

				currentTableColumns: [], // 当前显示的表格列

				// 按钮配置
				headerBtn: [{
						refesh: "refesh",
						title: "刷新",
						type: "",
						icon: "el-icon-refresh"
					},
					{
						senior: "senior",
						title: "高级",
						type: "",
						icon: "el-icon-zhinengfenxi"
					}
				],

				pickerOptions: {
					shortcuts: [{
							text: '今天',
							onClick(picker) {
								picker.$emit('pick', new Date());
							}
						},
						{
							text: '昨天',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24);
								picker.$emit('pick', date);
							}
						},
						{
							text: '一周前',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
								picker.$emit('pick', date);
							}
						}
					]
				},

				// 积分变动明细相关数据
				detailDialogVisible: false,
				detailData: [],
				detailTotal: 0,
				detailLoading: false,
				detailQueryParams: {
					pageNum: 1,
					pageSize: 10,
					phrClinicId: '' // 当前行的id
				},
				currentDetailPerson: '' // 当前查看的人员姓名
			};
		},
		computed: {
			// 计算属性：检查权限
			hasEditPermission() {
				return this.$store.getters.hasPermission('system:point:edit');
			},

			// 计算是否有任何行正在编辑
			isAnyRowEditing() {
				return this.tableData.some(item => item.isEditing);
			},

			// 计算是否有任何规则行正在编辑
			isAnyRowEditingRule() {
				return this.tableData.some(item => item.isEditing);
			}
		},
		async mounted() {
			this.loadData();
			this.$nextTick(() => {
				this.updateWindowWidth();
				window.addEventListener('resize', this.updateWindowWidth);
			});
			this.getAllTree();
			this.loadPointTypeSelectOptions(); // 确保加载积分分类下拉选项
			this.userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
			this.addForm.operator = this.userInfo.userName || '';

			// 设置当前表格列
			this.currentTableColumns = this.personPointsColumns;

			// 绑定全局点击事件，用于关闭右键菜单
			document.addEventListener('click', this.handleDocumentClick);
		},
		beforeDestroy() {
			// 移除事件监听
			document.removeEventListener('click', this.handleDocumentClick);
		},
		methods: {
			// ========== 新增搜索功能 ==========
			handleSearch() {
				console.log('搜索关键字:', this.searchValue);
				this.pageNum = 1; // 搜索时重置到第一页
				this.loadData();
			},

			// ========== 树菜单相关方法 ==========
			async getAllTree() {
				try {
					let res = await listAll();
					if (res.code === 200) {
						this.elTree[0].children = res.data.map(v => ({
							label: v.name,
							id: v.id,
							...v,
							// 为禁用的节点添加disabled属性
							disabled: v.state === 0
						}));

						// 设置默认展开的键
						this.defaultExpandedKeys = ['person_points'];
						this.currentTreeNodeKey = 'person_points';

						console.log('树菜单数据加载完成:', this.elTree);
					}
				} catch (error) {
					console.error('加载树菜单失败:', error);
					this.$message.error('加载分类数据失败');
				}
			},

			// 树节点点击事件
			handleNodeClick(data, node) {
				console.log('选择的树节点:', data);

				// 检查节点是否被禁用
				if (data.disabled === true) {
					this.$message.warning('该分类已被禁用，无法操作');
					return;
				}

				this.loading = true;

				if (data.id === 'person_points') {
					// 点击根节点：人员积分统计
					this.isPersonPointsMode = true;
					this.CatalogueName = '人员积分统计';
					this.currentTableColumns = this.personPointsColumns;
					this.customEmptyText = '暂无人员积分统计数据';

					// 更新面包屑
					this.breadcrumbItems = [{
						name: '人员积分统计',
						id: 'person_points',
						clickable: false
					}];

					this.loadPersonPointsData();
				} else {
					// 点击分类节点
					this.isPersonPointsMode = false;
					this.currentTableColumns = this.pointRuleColumns;
					this.categoryTitle = `${data.label} / 所有规则`;

					// 更新面包屑
					this.breadcrumbItems = [{
							name: '人员积分统计',
							id: 'person_points',
							clickable: true
						},
						{
							name: data.label,
							id: data.id,
							clickable: false
						}
					];

					// 重新加载当前节点的数据，确保数据是最新的
					this.loadCurrentTreeNodeData(data);
				}

				// 设置当前选中的树节点key（用于高亮）
				this.currentTreeNodeKey = data.id;
				this.currentTreeNode = data;

				// 重置搜索值
				this.searchValue = '';
				// 重置添加规则状态
				this.isAddingRule = false;
				this.resetNewRuleForm();
				// 关闭右键菜单
				this.treeContextMenu.visible = false;
			},

			// 新增方法：加载当前树节点的数据
			async loadCurrentTreeNodeData(treeNode) {
				this.tableLoading = true;
				try {
					// 重新获取该分类的详细信息，确保数据最新
					const response = await pointPhrTypeDetail({
						id: treeNode.id
					});
					if (response && response.code === 200) {
						// 更新当前树节点的数据
						this.currentTreeNode = {
							...treeNode,
							...response.data
						};

						// 加载该节点的表格数据
						this.loadPointRuleData(this.currentTreeNode);
					} else {
						this.$message.error(response?.message || '获取分类数据失败');
						this.loadPointRuleData(treeNode);
					}
				} catch (error) {
					console.error('加载当前节点数据失败:', error);
					this.$message.error('加载数据失败，请稍后重试');
					this.loadPointRuleData(treeNode);
				} finally {
					this.tableLoading = false;
					this.loading = false;
				}
			},

			// 树节点右键菜单事件
			handleTreeNodeContextMenu(event, data, node, element) {
				event.preventDefault();
				event.stopPropagation();

				// 计算菜单位置
				const rect = element.$el.getBoundingClientRect();
				this.treeContextMenu.x = rect.right + 5;
				this.treeContextMenu.y = rect.top;
				this.treeContextMenu.visible = true;

				// 判断节点类型
				if (data.id === 'person_points') {
					this.treeContextMenu.type = 'parent';
					this.treeContextMenu.data = data;
				} else {
					this.treeContextMenu.type = 'child';
					this.treeContextMenu.data = data;
				}
			},

			// 文档点击事件，用于关闭右键菜单
			handleDocumentClick() {
				this.treeContextMenu.visible = false;
			},

			// 右键菜单：添加分类
			handleAddCategoryFromContext() {
				this.treeContextMenu.visible = false;
				this.handleAddCategory();
			},

			// 右键菜单：刷新人员积分数据
			refreshPersonPointsData() {
				this.treeContextMenu.visible = false;
				this.loadPersonPointsData();
			},

			// 右键菜单：跳转到人员积分统计表格
			goToPersonPointsTable() {
				this.treeContextMenu.visible = false;
				this.handleNodeClick({
					id: 'person_points',
					label: '人员积分统计'
				}, null);
			},

			// 右键菜单：启用/禁用分类
			async toggleCategoryStatus() {
				this.treeContextMenu.visible = false;
				const data = this.treeContextMenu.data;

				try {
					const newState = data.state === 0 ? 1 : 0;
					const params = {
						id: data.id,
						name: data.name,
						birthPointNum: data.birthPointNum || 0,
						birthState: data.birthState || 0,
						ruleState: data.ruleState || 0,
						state: newState
					};

					const response = await editPhrType(params);
					if (response && response.code === 200) {
						this.$message.success(`该分类已${newState === 1 ? '启用' : '禁用'}`);

						// 如果当前选中的节点是当前节点，则清空选中状态
						if (this.currentTreeNode && this.currentTreeNode.id === data.id) {
							this.currentTreeNode = null;
							this.currentTreeNodeKey = 'person_points';

							// 跳转到根节点
							this.handleNodeClick({
								id: 'person_points',
								label: '人员积分统计'
							}, null);
						}

						// 重新加载树菜单
						await this.getAllTree();
					} else {
						this.$message.error(response?.message || '操作失败');
					}
				} catch (error) {
					console.error('切换分类状态失败:', error);
					this.$message.error('操作失败，请稍后重试');
				}
			},

			// 右键菜单：修改分类信息
			async editCategoryInfoFromContext() {
				this.treeContextMenu.visible = false;
				if (this.treeContextMenu.data && this.treeContextMenu.data.id) {
					await this.loadCategoryDetail(this.treeContextMenu.data.id, 'edit');
				} else {
					this.$message.warning('无法获取分类信息');
				}
			},

			// 右键菜单：显示分类详情
			async showCategoryDetail() {
				this.treeContextMenu.visible = false;
				await this.loadCategoryDetail(this.treeContextMenu.data.id, 'view');
			},

			// 右键菜单：跳转到分类表格
			async goToCategoryTable() {
				this.treeContextMenu.visible = false;
				const nodeData = this.treeContextMenu.data;

				// 先切换到对应的分类节点
				this.handleNodeClick(nodeData, null);

				// 等待表格加载完成后触发添加规则
				this.$nextTick(() => {
					setTimeout(() => {
						// 检查是否处于添加规则模式
						if (!this.isAddingRule) {
							this.handleAddRule();
						}
					}, 300);
				});
			},

			// 头部按钮：显示分类详情
			async showCategoryDetailFromHeader() {
				if (this.currentTreeNode && this.currentTreeNode.id) {
					await this.loadCategoryDetail(this.currentTreeNode.id, 'view');
				} else {
					this.$message.warning('请先选择一个分类');
				}
			},

			// 头部按钮：编辑分类信息
			async editCategoryInfoFromHeader() {
				if (this.currentTreeNode && this.currentTreeNode.id) {
					await this.loadCategoryDetail(this.currentTreeNode.id, 'edit');
				} else {
					this.$message.warning('请先选择一个分类');
				}
			},

			// 加载分类详情
			async loadCategoryDetail(categoryId, mode) {
				this.categoryDetailMode = mode;
				this.categoryDetailDialogTitle = mode === 'edit' ? '修改分类信息' : '分类详情';
				this.categoryDetailDialogVisible = true;
				this.categoryDetailData = null;
				this.categoryRuleList = [];

				try {
					const response = await pointPhrTypeDetail({
						id: categoryId
					});
					if (response && response.code === 200) {
						this.categoryDetailData = response.data;
						this.categoryRuleList = response.data.list || [];
					} else {
						this.$message.error(response?.message || '获取分类详情失败');
					}
				} catch (error) {
					console.error('获取分类详情失败:', error);
					this.$message.error('获取分类详情失败，请稍后重试');
				}
			},

			// 保存分类编辑
			async saveCategoryEdit() {
				if (!this.categoryDetailData) return;

				this.categoryEditLoading = true;
				try {
					const params = {
						id: this.categoryDetailData.id,
						name: this.categoryDetailData.name,
						birthPointNum: parseInt(this.categoryDetailData.birthPointNum) || 0,
						birthState: this.categoryDetailData.birthState,
						ruleState: this.categoryDetailData.ruleState,
						state: this.categoryDetailData.state
					};

					const response = await editPhrType(params);
					if (response && response.code === 200) {
						this.$message.success('分类信息更新成功');
						this.categoryDetailDialogVisible = false;
						// 重新加载树菜单
						this.getAllTree();
					} else {
						this.$message.error(response?.message || '更新失败');
					}
				} catch (error) {
					console.error('更新分类信息失败:', error);
					this.$message.error('更新失败，请稍后重试');
				} finally {
					this.categoryEditLoading = false;
				}
			},

			// 分类详情对话框关闭
			handleCategoryDetailDialogClose() {
				this.categoryDetailData = null;
				this.categoryRuleList = [];
			},

			// 面包屑点击事件
			handleBreadcrumbClick(item) {
				if (item.id === 'person_points') {
					// 点击"人员积分统计"返回主表格
					this.handleNodeClick({
						id: 'person_points',
						label: '人员积分统计'
					}, null);
				}
			},

			// ========== 数据加载方法 ==========
			async loadData() {
				if (this.isPersonPointsMode) {
					this.loadPersonPointsData();
				} else if (this.currentTreeNode) {
					this.loadPointRuleData(this.currentTreeNode);
				} else {
					this.loadPersonPointsData();
				}
			},

			// 加载人员积分统计数据
			async loadPersonPointsData() {
				this.tableLoading = true;
				try {
					let res = await pageList({
						pageNum: this.pageNum,
						pageSize: this.pageSize,
						personName: this.searchValue
					});

					if (res.code === 200 && res.data) {
						// 确保数据格式正确
						this.tableData = (res.data.content || []).map(item => {
							return {
								id: item.id || 0,
								personName: item.personName || '',
								sex: item.sex || 0,
								patId: item.patId || '',
								certNo: item.certNo || '',
								pointNum: item.pointNum || 0,
								tel: item.tel || '',
								pointPhrTypeName: item.pointPhrTypeName || '',
								pointPhrTypeId: item.pointPhrTypeId || null,
								editingPointPhrTypeId: item.pointPhrTypeId || null, // 编辑时使用的ID
								isEditing: false,
								saving: false
							};
						});
						this.totalSize = res.data.totalSize || 0;
						console.log('加载的人员积分数据:', this.tableData);
						this.$message.success(`已为您查询到${res.data.totalSize}条数据`);
					} else {
						this.tableData = [];
						this.$message.error(res.message || '获取数据失败');
					}
				} catch (error) {
					console.error('加载人员积分统计数据失败:', error);
					this.$message.error('加载数据失败');
					this.tableData = [];
				} finally {
					this.tableLoading = false;
					this.loading = false;
				}
			},

			// 性别格式化
			sexFormatter(row, column, cellValue) {
				const sexMap = {
					1: '男',
					2: '女',
					9: '未说明的性别',
					0: '未知的性别'
				};
				return sexMap[cellValue] || '未知';
			},
			// 获取分类选项的显示标签
			getCategoryOptionLabel(option) {
				if (option.disabled) {
					return `${option.label} (已禁用)`;
				}
				return option.label;
			},

			// 获取分类选项的悬停提示
			getCategoryOptionTitle(option) {
				if (option.disabled) {
					return '该分类已被禁用，不可选择';
				}
				return '已启用，可选择';
			},

			// 加载积分分类下拉选项
			async loadPointTypeSelectOptions() {
				try {
					const response = await listSelectAll();
					if (response && response.code === 200) {
						this.pointTypeSelectOptions = response.data.map(item => ({
							value: item.id,
							label: item.name,
							// 根据state字段设置是否禁用：state=0禁用，state=1启用
							disabled: item.state === 0,
							state: item.state
						}));
						console.log('积分分类下拉选项加载成功:', this.pointTypeSelectOptions);
					} else {
						this.$message.error(response?.message || '加载积分分类选项失败');
						this.pointTypeSelectOptions = [];
					}
				} catch (error) {
					console.error('加载积分分类下拉选项失败:', error);
					this.$message.error('加载积分分类选项失败，请稍后重试');
					this.pointTypeSelectOptions = [];
				}
			},

			// 编辑状态下积分分类选择变更
			handleEditingPointTypeChange(row) {
				// 当选择变更时，可以在这里做一些处理
				console.log('编辑状态下的积分分类变更:', row.editingPointPhrTypeId);
			},

			// 加载积分规则数据
			async loadPointRuleData(treeNode) {
				this.tableLoading = true;
				try {
					// 直接使用树节点中的list数据
					const listData = treeNode.list || [];

					console.log('加载积分规则数据，listData:', listData);

					// 格式化表格数据
					this.tableData = listData.map(item => ({
						id: item.id || 0,
						pointPhrTypeName: item.pointPhrTypeName || '',
						pointPhrTypeId: item.pointPhrTypeId || null,
						editingPointPhrTypeId: item.pointPhrTypeId || null,
						pointPricStart: item.pointPricStart || 0,
						editingPointPricStart: item.pointPricStart || 0,
						pointPricEnd: item.pointPricEnd || 0,
						editingPointPricEnd: item.pointPricEnd || 0,
						pointSalePric: item.pointSalePric || 0,
						editingPointSalePric: item.pointSalePric || 0,
						remark: item.remark || '',
						editingRemark: item.remark || '',
						state: item.state || 0,
						editingState: item.state || 0,
						stateLoading: false, // 状态切换加载状态
						createName: item.createName || '',
						createTime: item.createTime || '',
						isNew: false,
						isEditing: false,
						saving: false
					}));

					// 设置自定义空状态文本
					this.customEmptyText = this.tableData.length === 0 ? '该分类下暂无积分规则' : '';

					if (listData.length === 0) {
						this.$message.info('该分类下暂无积分规则');
					} else {
						this.$message.success(`已为您查询到${listData.length}条积分规则`);
					}
				} catch (error) {
					console.error('加载积分规则数据失败:', error);
					this.$message.error('加载积分规则数据失败');
					this.tableData = [];
					this.customEmptyText = '加载数据失败，请重试';
				} finally {
					this.tableLoading = false;
					this.loading = false;
				}
			},

			// ========== 人员积分统计编辑相关方法 ==========
			// 开始编辑
			async startEdit(row) {
				// 先取消其他行的编辑状态
				this.cancelAllEdit();

				// 重新加载积分分类下拉选项
				await this.reloadPointTypeSelectOptionsWithStatus();

				// 设置当前行为编辑状态
				row.isEditing = true;
				// 初始化编辑时的分类ID
				row.editingPointPhrTypeId = row.pointPhrTypeId;
			},

			// 重新加载积分分类下拉选项（带状态）
			async reloadPointTypeSelectOptionsWithStatus() {
				try {
					const response = await listSelectAll();
					if (response && response.code === 200) {
						this.pointTypeSelectOptions = response.data.map(item => ({
							value: item.id,
							label: item.name,
							// 根据状态设置是否禁用
							disabled: item.state === 0
						}));
						console.log('重新加载积分分类下拉选项成功（带状态）:', this.pointTypeSelectOptions);

						// 如果当前行的分类被禁用，需要特殊处理
						const currentRow = this.tableData.find(row => row.isEditing);
						if (currentRow && currentRow.pointPhrTypeId) {
							const currentOption = response.data.find(item => item.id === currentRow.pointPhrTypeId);
							if (!currentOption) {
								// 如果当前分类在列表中不存在（可能被禁用），添加一个禁用的选项
								this.pointTypeSelectOptions.unshift({
									value: currentRow.pointPhrTypeId,
									label: currentRow.pointPhrTypeName || '已禁用分类',
									disabled: true
								});
							}
						}
					} else {
						this.$message.error(response?.message || '重新加载积分分类选项失败');
					}
				} catch (error) {
					console.error('重新加载积分分类下拉选项失败:', error);
					this.$message.error('重新加载积分分类选项失败');
				}
			},

			// 重新加载积分分类下拉选项
			async reloadPointTypeSelectOptions() {
				try {
					const response = await listSelectAll();
					if (response && response.code === 200) {
						this.pointTypeSelectOptions = response.data.map(item => ({
							value: item.id,
							label: item.name
						}));
						console.log('重新加载积分分类下拉选项成功:', this.pointTypeSelectOptions);
					} else {
						this.$message.error(response?.message || '重新加载积分分类选项失败');
					}
				} catch (error) {
					console.error('重新加载积分分类下拉选项失败:', error);
					this.$message.error('重新加载积分分类选项失败');
				}
			},

			// 检查是否是编辑行
			isEditingRow(row) {
				return row.isEditing === true;
			},

			// 取消编辑
			cancelEdit(row) {
				row.isEditing = false;
				row.saving = false;
				// 恢复编辑前的分类ID
				row.editingPointPhrTypeId = row.pointPhrTypeId;
			},

			// 取消所有编辑
			cancelAllEdit() {
				this.tableData.forEach(row => {
					if (row.isEditing) {
						this.cancelEdit(row);
					}
				});
			},

			// 保存编辑
			async saveEdit(row) {
				if (!row.editingPointPhrTypeId) {
					this.$message.warning('请选择积分分类');
					return;
				}

				// 检查选择的分类是否被禁用
				const selectedCategory = this.pointTypeSelectOptions.find(
					option => option.value === row.editingPointPhrTypeId
				);

				if (selectedCategory && selectedCategory.disabled) {
					this.$message.warning('不能选择已禁用的积分分类');
					return;
				}

				row.saving = true;
				try {
					const response = await updateType({
						id: row.id,
						pointPhrTypeId: row.editingPointPhrTypeId
					});

					if (response && response.code === 200) {
						// 更新显示的名称
						const selectedOption = this.pointTypeSelectOptions.find(
							option => option.value === row.editingPointPhrTypeId
						);
						if (selectedOption) {
							row.pointPhrTypeName = selectedOption.label;
							row.pointPhrTypeId = row.editingPointPhrTypeId;
						}

						this.$message.success(`当前${row.personName}的积分分类已更新！`);

						// 退出编辑状态
						row.isEditing = false;
						row.saving = false;
					} else {
						this.$message.error(response?.message || '更新失败');
					}
				} catch (error) {
					console.error('更新失败:', error);
					this.$message.error('更新失败，请稍后重试');
				} finally {
					row.saving = false;
				}
			},

			// ========== 积分规则编辑相关方法 ==========
			// 开始编辑规则
			async startEditRule(row) {
				// 先检查是否已有其他行正在编辑
				if (this.isAnyRowEditingRule && !row.isEditing) {
					this.$message.warning('请先完成当前行的编辑操作');
					return;
				}

				// 检查是否处于添加规则模式
				if (this.isAddingRule) {
					this.$message.warning('请先完成或取消添加规则操作');
					return;
				}

				// 先取消其他行的编辑状态
				this.cancelAllEditRule();

				// 重新加载积分分类下拉选项
				await this.reloadPointTypeSelectOptions();

				// 设置当前行为编辑状态
				row.isEditing = true;
				// 初始化编辑时的值
				row.editingPointPhrTypeId = row.pointPhrTypeId;
				row.editingPointPricStart = row.pointPricStart;
				row.editingPointPricEnd = row.pointPricEnd;
				row.editingPointSalePric = row.pointSalePric;
				row.editingRemark = row.remark;
				row.editingState = row.state;
			},

			// 取消编辑规则
			cancelEditRule(row) {
				row.isEditing = false;
				row.saving = false;
				// 恢复原始数据
				row.editingPointPhrTypeId = row.pointPhrTypeId;
				row.editingPointPricStart = row.pointPricStart;
				row.editingPointPricEnd = row.pointPricEnd;
				row.editingPointSalePric = row.pointSalePric;
				row.editingRemark = row.remark;
				row.editingState = row.state;
			},

			// 取消所有规则编辑
			cancelAllEditRule() {
				this.tableData.forEach(row => {
					if (row.isEditing) {
						this.cancelEditRule(row);
					}
				});
			},

			// 保存编辑规则
			async saveEditRule(row) {
				// 验证必填字段
				if (row.editingPointPricStart === null || row.editingPointPricStart < 0) {
					this.$message.warning('请输入大于等于0的消费金额下限');
					return;
				}

				if (row.editingPointPricEnd === null || row.editingPointPricEnd < 0) {
					this.$message.warning('请输入大于等于0的消费金额上限');
					return;
				}

				if (row.editingPointPricEnd < row.editingPointPricStart) {
					this.$message.warning('消费金额上限必须大于等于消费金额下限');
					return;
				}

				if (row.editingPointSalePric === null || row.editingPointSalePric < 0) {
					this.$message.warning('请输入大于等于0的生成1积分所需金额');
					return;
				}

				row.saving = true;
				try {
					const params = {
						id: row.id,
						pointPhrTypeId: row.editingPointPhrTypeId,
						pointPricStart: row.editingPointPricStart,
						pointPricEnd: row.editingPointPricEnd,
						pointSalePric: row.editingPointSalePric,
						remark: row.editingRemark || '',
						state: row.editingState
					};

					const response = await editPointsRule(params);
					if (response && response.code === 200) {
						// 更新显示的数据
						row.pointPhrTypeName = this.pointTypeSelectOptions.find(
							option => option.value === row.editingPointPhrTypeId
						)?.label || row.pointPhrTypeName;
						row.pointPhrTypeId = row.editingPointPhrTypeId;
						row.pointPricStart = row.editingPointPricStart;
						row.pointPricEnd = row.editingPointPricEnd;
						row.pointSalePric = row.editingPointSalePric;
						row.remark = row.editingRemark;
						row.state = row.editingState;

						this.$message.success('积分规则修改成功');
						row.isEditing = false;
						row.saving = false;
					} else {
						this.$message.error(response?.message || '修改失败');
					}
				} catch (error) {
					console.error('修改积分规则失败:', error);
					this.$message.error('修改失败，请稍后重试');
				} finally {
					row.saving = false;
				}
			},

			// ========== 新增积分规则相关方法 ==========
			// 添加规则
			handleAddRule() {
				// 检查是否已有行正在编辑
				if (this.isAnyRowEditingRule) {
					this.$message.warning('请先完成当前行的编辑操作');
					return;
				}

				this.isAddingRule = true;
				this.resetNewRuleForm();

				// 设置积分人员分类为当前选择的分类名称
				if (this.currentTreeNode) {
					this.newRule.pointPhrTypeName = this.currentTreeNode.label;
				}

				// 在表格数据末尾添加新行
				const newRow = {
					id: 0,
					pointPhrTypeName: this.currentTreeNode ? this.currentTreeNode.label : '',
					pointPhrTypeId: this.currentTreeNode ? this.currentTreeNode.id : null,
					pointPricStart: null,
					editingPointPricStart: null,
					pointPricEnd: null,
					editingPointPricEnd: null,
					pointSalePric: 0,
					editingPointSalePric: 0,
					remark: '',
					editingRemark: '',
					state: 1,
					editingState: 1,
					stateLoading: false,
					createName: '',
					createTime: '',
					isNew: true,
					isEditing: false
				};

				this.tableData.push(newRow);
			},

			// 取消添加规则
			cancelAddRule() {
				this.isAddingRule = false;
				this.resetNewRuleForm();

				// 移除新增的行
				this.tableData = this.tableData.filter(row => !row.isNew);
			},

			// 重置新增规则表单
			resetNewRuleForm() {
				this.newRule = {
					pointPhrTypeName: this.currentTreeNode ? this.currentTreeNode.label : '',
					pointPricStart: null,
					pointPricEnd: null,
					pointSalePric: 0,
					remark: '',
					state: 1
				};
			},

			// 确认添加规则
			confirmAddRule() {
				// 验证必填字段
				if (this.newRule.pointPricStart === null || this.newRule.pointPricStart < 0) {
					this.$message.warning('请输入大于等于0的消费金额下限');
					return;
				}

				if (this.newRule.pointPricEnd === null || this.newRule.pointPricEnd < 0) {
					this.$message.warning('请输入大于等于0的消费金额上限');
					return;
				}

				if (this.newRule.pointPricEnd < this.newRule.pointPricStart) {
					this.$message.warning('消费金额上限必须大于等于消费金额下限');
					return;
				}

				if (this.newRule.pointSalePric === null || this.newRule.pointSalePric < 0) {
					this.$message.warning('请输入大于等于0的生成1积分所需金额');
					return;
				}

				this.addRuleLoading = true;
				this.submitAddRule();
			},

			// 提交添加规则
			async submitAddRule() {
				try {
					const submitData = {
						pointPhrTypeId: this.currentTreeNode.id, // 使用当前分类的id
						pointPricStart: this.newRule.pointPricStart,
						pointPricEnd: this.newRule.pointPricEnd,
						pointSalePric: this.newRule.pointSalePric || 0,
						remark: this.newRule.remark || '',
						state: this.newRule.state
					};

					console.log('提交新增规则数据:', submitData);

					const response = await addPointsRule(submitData);

					if (response && response.code === 200) {
						this.$message.success(`已为${this.newRule.pointPhrTypeName}添加新的规则！`);
						this.isAddingRule = false;
						this.resetNewRuleForm();

						// 重新加载树菜单和当前分类的数据
						await this.reloadTreeAndCurrentData();
					} else {
						this.$message.error(response?.message || '添加积分规则失败');
					}
				} catch (error) {
					console.error('添加积分规则失败:', error);
					this.$message.error('添加积分规则失败，请稍后重试');
				} finally {
					this.addRuleLoading = false;
				}
			},

			// 重新加载树菜单和当前分类数据
			async reloadTreeAndCurrentData() {
				try {
					// 重新获取树菜单数据
					const res = await listAll();
					if (res.code === 200) {
						// 更新树菜单
						this.elTree[0].children = res.data.map(v => ({
							label: v.name,
							id: v.id,
							...v
						}));

						// 如果当前有选中的树节点，重新加载该节点的数据
						if (this.currentTreeNode && this.currentTreeNode.id) {
							// 找到最新的当前节点数据
							const latestCurrentNode = res.data.find(node => node.id === this.currentTreeNode.id);
							if (latestCurrentNode) {
								this.currentTreeNode = latestCurrentNode;
								// 重新加载该节点的表格数据
								await this.loadPointRuleData(latestCurrentNode);
							}
						}
					}
				} catch (error) {
					console.error('重新加载树菜单失败:', error);
					this.$message.error('重新加载数据失败');
				}
			},

			// ========== 状态切换方法 ==========
			// ========== 状态切换方法 ==========
			async handleStateChange(row) {
				row.stateLoading = true;
				const originalState = row.state; // 保存原始状态
				try {
					const response = await updatePointsRule({
						id: row.id,
						state: row.state
					});

					if (response && response.code === 200) {
						const actionText = row.state === 1 ? '已启用' : '已禁用';
						this.$message.success(`阶梯规则（${row.pointPricStart}-${row.pointPricEnd}）${actionText}`);

						// 不再重新加载整个表格，因为可能会覆盖其他行的编辑状态
						// 而是直接更新当前行的状态显示
						// 确保开关状态保持更新后的状态
						row.stateLoading = false;
					} else {
						// 恢复原状态
						row.state = originalState;
						this.$message.error(response?.message || '状态更新失败');
						row.stateLoading = false;
					}
				} catch (error) {
					console.error('状态更新失败:', error);
					row.state = originalState;
					this.$message.error('状态更新失败，请稍后重试');
					row.stateLoading = false;
				}
			},
			// ========== 积分规则详情相关方法 ==========
			async handleRuleDetail(row) {
				this.ruleDetailTitle = '积分规则详情';
				this.ruleDetailDialogVisible = true;
				this.currentRuleDetail = null;

				try {
					const response = await pointsRuleDetails({
						id: row.id
					});

					if (response && response.code === 200) {
						this.currentRuleDetail = response.data || {};
					} else {
						this.$message.error(response?.message || '获取规则详情失败');
					}
				} catch (error) {
					console.error('获取规则详情失败:', error);
					this.$message.error('获取规则详情失败，请稍后重试');
				}
			},

			// 积分规则详情对话框关闭
			handleRuleDetailDialogClose() {
				this.currentRuleDetail = null;
			},

			// ========== 删除积分规则 ==========
			async handleDeleteRule(row) {
				this.$confirm('确定要删除这条积分规则吗？', '提示', {
					type: 'warning',
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				}).then(async () => {
					try {
						const response = await deleteRule({
							id: row.id
						});

						if (response && response.code === 200) {
							this.$message.success(
								`${row.pointPhrTypeName}对应的${row.pointPricStart}-${row.pointPricEnd}规则已删除！`
							);

							// 重新加载树菜单和当前分类的数据
							await this.reloadTreeAndCurrentData();
						} else {
							this.$message.error(response?.message || '删除失败');
						}
					} catch (error) {
						console.error('删除失败:', error);
						this.$message.error('删除失败，请稍后重试');
					}
				}).catch(() => {});
			},

			// ========== 扣减积分相关方法 ==========
			// 打开扣减积分模态框
			async handleDeductPoints(row) {
				this.currentDeductPerson = row;
				this.deductDialogTitle = `为${row.personName}进行积分扣减`;
				this.deductDialogVisible = true;

				// 初始化表单数据
				this.deductForm = {
					bizSouc: null,
					phrClinicId: row.id, // 使用当前行的id作为phrClinicId
					reduceNum: 1,
					remark: ''
				};

				// 加载业务来源下拉选项
				await this.loadBizSoucOptions();

				// 清除表单验证
				if (this.$refs.deductForm) {
					this.$refs.deductForm.clearValidate();
				}
			},

			// 加载业务来源下拉选项
			async loadBizSoucOptions() {
				try {
					// 假设接口为point_souc，您需要根据实际接口名调整
					const response = await point_souc();
					if (response && response.code === 200) {
						this.bizSoucOptions = response.data.map(item => ({
							value: item.bizSouc, // id
							label: item.bizSoucName // 名称
						}));
					} else {
						this.$message.error(response?.message || '加载业务来源失败');
						this.bizSoucOptions = [];
					}
				} catch (error) {
					console.error('加载业务来源失败:', error);
					this.$message.error('加载业务来源失败，请稍后重试');
					this.bizSoucOptions = [];
				}
			},

			// 提交扣减积分
			async submitDeductPoints() {
				this.$refs.deductForm.validate(async (valid) => {
					if (valid) {
						this.deductLoading = true;
						try {
							// 准备提交数据
							const submitData = {
								bizSouc: this.deductForm.bizSouc,
								phrClinicId: this.deductForm.phrClinicId,
								reduceNum: parseInt(this.deductForm.reduceNum),
								remark: this.deductForm.remark || ''
							};

							// 调用扣减积分接口，假设接口为addReduce
							const response = await addReduce(submitData);

							if (response && response.code === 200) {
								this.$message.success(
									`已将${this.currentDeductPerson.personName}的积分成功扣减${this.deductForm.reduceNum}`
									);
								this.deductDialogVisible = false;

								// 重新加载人员积分数据
								this.loadPersonPointsData();
							} else {
								this.$message.error(response?.message || '扣减积分失败');
							}
						} catch (error) {
							console.error('扣减积分失败:', error);
							this.$message.error('扣减积分失败，请稍后重试');
						} finally {
							this.deductLoading = false;
						}
					} else {
						this.$message.warning('请填写完整的扣减信息');
						return false;
					}
				});
			},

			// 扣减积分模态框关闭
			handleDeductDialogClose() {
				this.deductDialogVisible = false;
				this.currentDeductPerson = null;
				this.deductForm = {
					bizSouc: null,
					phrClinicId: null,
					reduceNum: 1,
					remark: ''
				};

				if (this.$refs.deductForm) {
					this.$refs.deductForm.clearValidate();
				}
			},

			// 跳转到扣减明细页面
			goToPointsDeductPage() {
				this.$router.push('/points/pointsDeduct');
			},
			// 处理扣减数量输入
			handleReduceNumInput(value) {
				// 过滤非数字字符，但允许空值
				if (value !== '' && value !== null) {
					// 移除所有非数字字符
					const filteredValue = value.replace(/[^\d]/g, '');
					// 如果过滤后的值与原值不同，则更新
					if (filteredValue !== value) {
						this.$nextTick(() => {
							this.deductForm.reduceNum = filteredValue;
						});
					}
				}
			},
			
			// ========== 新增分类相关方法 ==========
			// 添加分类
			handleAddCategory() {
				this.addCategoryDialogVisible = true;
			},

			// 提交新增分类
			async handleSubmitAddCategory() {
				this.$refs.addCategoryForm.validate(async (valid) => {
					if (valid) {
						this.addCategoryLoading = true;
						try {
							const response = await addPhrType(this.addCategoryForm);

							if (response && response.code === 200) {
								this.$message.success('新建分类已完成');
								this.addCategoryDialogVisible = false;
								this.resetAddCategoryForm();
								// 重新加载树菜单数据
								this.getAllTree();
							} else {
								this.$message.error(response?.message || '新建分类失败');
							}
						} catch (error) {
							console.error('新建分类失败:', error);
							this.$message.error('新建分类失败，请稍后重试');
						} finally {
							this.addCategoryLoading = false;
						}
					} else {
						this.$message.warning('请填写完整信息');
						return false;
					}
				});
			},

			// 重置新增分类表单
			resetAddCategoryForm() {
				this.addCategoryForm = {
					name: '',
					birthPointNum: 0,
					birthState: 1,
					ruleState: 1,
					state: 1
				};

				if (this.$refs.addCategoryForm) {
					this.$refs.addCategoryForm.clearValidate();
				}
			},

			// 新增分类对话框关闭
			handleAddCategoryDialogClose() {
				this.addCategoryDialogVisible = false;
				this.resetAddCategoryForm();
			},

			// ========== 表格操作相关方法 ==========
			// 处理行点击事件
			handleRowClick(row, column, event) {
				this.currentTable = row;
				this.setCurrent(row);
			},

			// 处理行鼠标进入事件
			handleRowMouseEnter(row, column, event) {
				// 如果行状态为禁用，则添加提示
				if (row.state === 0 && !row.isNew) {
					// 获取当前行元素
					const rowElement = event.currentTarget;
					rowElement.title = '该分类规则目前处于锁定状态！如需对其进行操作，请先去启用该规则！';
				}
			},

			// 处理行鼠标离开事件
			handleRowMouseLeave(row, column, event) {
				// 清除提示
				const rowElement = event.currentTarget;
				rowElement.title = '';
			},

			// 表格行类名
			tableRowClassName({
				row,
				rowIndex
			}) {
				if (row.state === 0 && !row.isNew) {
					return 'disabled-row';
				}
				return '';
			},

			// 设置当前行高亮
			setCurrent(row) {
				this.$nextTick(() => {
					if (this.$refs.singleTable) {
						this.$refs.singleTable.setCurrentRow(row);
					}
				});
			},

			// 处理行双击事件
			handledbRow(row, column, event) {
				if (row) {
					// 判断该行是否处于禁用状态
					if (row.state === 0) {
						this.$message.warning('该分类规则目前处于锁定状态！如需对其进行操作，请先去启用该规则！');
						return;
					}

					// 判断是否处于编辑模式
					if (this.isAnyRowEditing) {
						this.$message.warning('当前处于编辑模式，请先完成或取消编辑操作');
						return;
					}

					// 判断是否处于添加规则模式
					if (this.isAddingRule) {
						this.$message.warning('当前处于添加规则模式，请先完成或取消添加操作');
						return;
					}

					this.dialogMode = 'view';
					// 这里可以根据模式调用不同的详情查看方法
					if (this.isPersonPointsMode) {
						this.handlePointDetail(row);
					} else {
						this.handleRuleDetail(row);
					}
				}
			},

			// ========== 操作按钮方法 ==========
			// 查看积分变动明细
			async handlePointDetail(row) {
				this.currentDetailPerson = row.personName;
				this.detailQueryParams.phrClinicId = row.id;
				this.detailQueryParams.pageNum = 1;
				this.detailQueryParams.pageSize = 10;
				this.detailDialogVisible = true;
				await this.fetchDetailData();
			},

			// 获取积分变动明细数据
			async fetchDetailData() {
				this.detailLoading = true;
				try {
					const response = await chgDetail({
						pageNum: this.detailQueryParams.pageNum,
						pageSize: this.detailQueryParams.pageSize,
						phrClinicId: this.detailQueryParams.phrClinicId
					});

					if (response && response.code === 200) {
						const data = response.data?.content || [];
						this.detailData = data;
						this.detailTotal = response.data?.totalSize || 0;
					} else {
						this.$message.error(response?.message || '获取积分变动明细失败');
					}
				} catch (error) {
					console.error('获取积分变动明细失败:', error);
					this.$message.error('获取积分变动明细失败，请稍后重试');
				} finally {
					this.detailLoading = false;
				}
			},

			// 积分变动明细每页数量变化
			handleDetailSizeChange(size) {
				this.detailQueryParams.pageSize = size;
				this.detailQueryParams.pageNum = 1;
				this.fetchDetailData();
			},

			// 积分变动明细页码变化
			handleDetailCurrentChange(page) {
				this.detailQueryParams.pageNum = page;
				this.fetchDetailData();
			},

			// 积分变动明细对话框关闭
			handleDetailDialogClose() {
				this.detailData = [];
				this.detailTotal = 0;
				this.detailQueryParams.pageNum = 1;
				this.detailQueryParams.pageSize = 10;
				this.detailQueryParams.phrClinicId = '';
				this.currentDetailPerson = '';
			},

			// ========== 其他方法 ==========
			// 状态筛选
			handleCommand(command) {
				console.log('状态筛选:', command);
				if (command === 'a') {
					this.state = 1;
					this.DropDownedName = '可用';
				} else if (command === 'b') {
					this.state = 0;
					this.DropDownedName = '禁用';
				} else if (command === 'c') {
					this.state = '';
					this.DropDownedName = '全部';
				}
				this.loadData();
			},

			// 分页处理
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.pageSize = val;
				this.pageNum = 1;
				this.loadData();
			},

			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.pageNum = val;
				this.loadData();
			},

			// 顶部按钮处理
			handClick(i) {
				switch (i) {
					case 0: // 刷新
						this.loading = true;
						setTimeout(() => {
							this.loadPersonPointsData();
							this.$message.success('已刷新');
							this.loading = false;
						}, 500);
						break;
					case 1: // 高级
						this.$message.info('高级搜索功能开发中');
						break;
				}
			},

			// 列宽计算
			columnWidth(col, list) {
				let prop = col.prop,
					lab = col.name;
				let width = 120;
				let maxlenStr = "";

				for (let info of list) {
					if (maxlenStr < ((info[prop] || '') + "").length) maxlenStr = (info[prop] || '');
				}

				width = Math.max(width, this.len(lab), this.len(maxlenStr));
				return width + 20;
			},

			len(str) {
				let length = 0;
				if (!str) return 12;

				for (const char of str + "") {
					if ("a" <= char && char <= "z") length += 8;
					else if ("A" <= char && char <= "Z") length += 8;
					else if (char >= "\u4e00" && char <= "\u9fa5") length += 16;
					else length += 8;
				}
				return length;
			},

			// 窗口宽度更新
			updateWindowWidth() {
				this.windowWidth = window.innerWidth - 368;
			}
		}
	};
</script>

<style lang="less" scoped>
	.box {
		height: calc(100vh - 100px);
		width: 100%;
		overflow: hidden;

		/deep/ .el-table {
			.cell {
				font-size: 12px;
				text-overflow: ellipsis;
				white-space: nowrap;
				overflow: hidden;
			}

			th {
				font-size: 12px;
				background-color: #f8f9fa;
				border: none;
				color: #2d2d2d;
				font-weight: bold;
				padding: 8px 0;
			}

			td {
				padding: 6px 0;
			}

			.el-table__body-wrapper {
				overflow-x: auto;
			}

			// 隐藏表格自带的空状态
			.el-table__empty-block {
				display: none;
			}

			// 积分数量高亮样式
			.point-num-highlight {
				color: #409EFF;
				font-weight: bold;
				font-size: 14px;
			}
		}
		
		// 禁用行样式
		/deep/ .disabled-row {
			opacity: 0.6;
			background-color: #f8f8f8;
			cursor: not-allowed;

			&:hover {
				background-color: #f8f8f8;
			}

			td {
				color: #c0c4cc;
			}

			// 禁用行中的按钮样式
			.el-button:disabled {
				opacity: 0.5;
			}
		}

		// 禁用行鼠标悬停提示
		.el-table__row {
			&[title]:hover::after {
				content: attr(title);
				position: absolute;
				background-color: #333;
				color: #fff;
				padding: 5px 10px;
				border-radius: 4px;
				font-size: 12px;
				z-index: 1000;
				white-space: nowrap;
				pointer-events: none;
				margin-top: -30px;
			}
		}
		
		/* 自定义高亮颜色 */
		/deep/ .el-table__body tr.current-row>td {
			background-color: #ecf5ff !important;
			color: #409EFF;
		}

		.main {
			display: flex;
			height: 100%;
			width: 100%;
			background: #f5f7fa;

			// 左侧树形菜单
			.main-left {
				width: 200px;
				height: 100%;
				background: #fff;
				border-right: 1px solid #e6e6e6;
				overflow-y: auto;
				box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);

				.tree-header {
					display: flex;
					align-items: center;
					justify-content: space-between;
					padding: 12px 16px;
					border-bottom: 1px solid #e6e6e6;
					background-color: #f8f9fa;
				}
				
				// 树菜单禁用状态样式
				/deep/ .el-tree {
					
					.el-tree-node {
						// 禁用节点样式
						&.is-disabled {
							.el-tree-node__content {
								cursor: not-allowed;
								background-color: #f5f5f5;
								opacity: 0.6;

								&:hover {
									background-color: #f5f5f5;
								}

								.custom-tree-node {
									color: #c0c4cc;

									i {
										color: #c0c4cc;
									}

									.node-status {
										background-color: rgba(192, 196, 204, 0.3);
									}
								}
							}

							// 禁用状态下的右键菜单悬停效果
							&.is-current>.el-tree-node__content {
								background-color: #f5f5f5;
								color: #c0c4cc;

								&::before {
									background-color: #c0c4cc;
								}
							}
						}
					}
				}
				
				// 右键菜单禁用按钮样式
				.tree-context-menu {
					.el-button {
						&.is-disabled {
							color: #c0c4cc;
							cursor: not-allowed;
							background-color: transparent;

							&:hover {
								background-color: transparent;
								color: #c0c4cc;
							}

							i {
								color: #c0c4cc;
							}
						}
					}
				}

				/deep/ .el-button+.el-button,
				.el-checkbox.is-bordered+.el-checkbox.is-bordered {
					margin-left: 0;
				}
				
				/deep/ .el-card__body {
					padding: 8px;
				}
				
				// 树节点悬停效果
				.el-tree-node__content:hover {
					background: linear-gradient(90deg, #f0f9ff 0%, #f5f7fa 100%);
					transition: all 0.3s ease;
					box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
				}

				// 树节点展开/收起动画
				.el-tree-node__expand-icon {
					transition: transform 0.3s ease;

					&.expanded {
						transform: rotate(90deg);
					}
				}

				// 树节点状态样式
				.custom-tree-node {

					.node-status {
						display: inline-flex;
						align-items: center;
						justify-content: center;
						width: 16px;
						height: 16px;
						border-radius: 50%;
						background-color: rgba(0, 0, 0, 0.05);

						&.enabled {
							background-color: rgba(103, 194, 58, 0.1);
						}

						&.disabled {
							background-color: rgba(245, 108, 108, 0.1);
						}
					}
				}

				// 禁用状态的树节点
				/deep/ .el-tree-node.is-disabled>.el-tree-node__content {
					opacity: 0.5;
					cursor: not-allowed;

					.custom-tree-node {
						color: #c0c4cc;
					}
				}
				// 树菜单右键菜单样式
				.tree-context-menu {
					.el-card {
						border-radius: 4px;
						border: 1px solid #ebeef5;
						box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);

						.el-button {
							width: 100%;
							text-align: left;
							font-size: 12px;
							color: #606266;

							&:hover {
								background-color: #f5f7fa;
								color: #409EFF;
							}

							i {
								margin-right: 6px;
							}
						}
					}
				}
			}

			// 右侧内容区域
			.main-right {
				flex: 1;
				display: flex;
				flex-direction: column;
				height: 100%;
				overflow: hidden;
				padding: 0;
				background: #fff;

				// 面包屑导航
				.breadcrumb-section {
					padding: 12px 20px;
					border-bottom: 1px solid #e6e6e6;
					background-color: #fff;

					/deep/ .el-breadcrumb__inner {
						color: #606266;
						transition: color 0.2s;

						&:hover {
							color: #409EFF;
							cursor: pointer;
						}
					}

					.breadcrumb-active {
						/deep/ .el-breadcrumb__inner {
							color: #409EFF;
							font-weight: bold;
							cursor: default;
						}
					}
				}

				// 分类节点标题区域
				.category-header {
					padding: 12px 20px;
					border-bottom: 1px solid #e6e6e6;
					background-color: #fff;

					.category-title {
						display: flex;
						align-items: center;
					}
				}

				// 顶部搜索区域
				.main-icon {
					display: flex;
					align-items: center;
					padding: 16px 20px;
					background: #fff;
					border-bottom: 1px solid #e6e6e6;
					box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

					.main-icon-a {
						display: flex;
						align-items: center;
					}

					.main-icon-b {
						margin: 0 20px;

						/deep/ .el-dropdown {
							font-size: 12px;
							cursor: pointer;

							&:hover {
								color: #409EFF;
							}
						}
					}

					.main-icon-c {
						margin: 0 10px;
						display: flex;
						align-items: center;

						/deep/ .el-input {
							width: 200px;
						}
					}
				}

				// 表格容器
				.table-container {
					flex: 1;
					display: flex;
					flex-direction: column;
					padding: 16px;
					overflow: hidden;

					.table-wrapper {
						flex: 1;
						overflow: hidden;
						border-radius: 4px;
						border: 1px solid #e6e6e6;
						background: #fff;
						position: relative;

						/deep/ .el-table {
							height: 100%;

							.action-buttons {
								display: flex;
								justify-content: center;
								gap: 4px;

								.el-button {
									margin: 0;
									padding: 5px 8px;
									font-size: 12px;
									min-width: auto;

									/* 禁用状态样式 */
									&.is-disabled {
										opacity: 0.5;
										cursor: not-allowed;
									}
								}
							}

							// 编辑模式下积分分类单元格样式
							.editing-cell {
								.el-select {
									width: 100%;
								}
							}
						}
					}
				}
			}
		}
	}

	// 扣减积分模态框样式
	/deep/ .deduct-points-dialog {
		.el-dialog {
			border-radius: 8px;

			&__header {
				background-color: #fef0f0;
				border-bottom: 1px solid #fde2e2;

				.el-dialog__title {
					color: #f56c6c;
					font-weight: bold;
				}
			}

			&__body {
				.el-form-item {
					margin-bottom: 20px;

					&__label {
						font-weight: 500;
						color: #606266;
					}
				}
			}

			&__footer {
				border-top: 1px solid #e6e6e6;
			}
		}
	}

	// 模态框圆角样式
	/deep/ .custom-dialog {
		.el-dialog {
			border-radius: 4px;
			overflow: hidden;

			&__header {
				background-color: #f0f9ff;
				padding: 15px 20px;
				border-bottom: 1px solid #e6e6e6;

				.el-dialog__title {
					color: #409EFF;
					font-weight: bold;
				}
			}

			&__body {
				padding: 20px;
			}

			&__footer {
				border-top: 1px solid #e6e6e6;
				padding: 15px 20px;
				text-align: right;
			}
		}
	}

	// 新建积分分类模态框特殊样式
	/deep/ .category-create-dialog {
		.el-dialog {
			&__header {
				background-color: #f0f9ff;
			}
		}

		.el-form-item {
			margin-bottom: 20px;

			&__label {
				font-weight: 500;
				color: #606266;
			}

			&__error {
				color: #f56c6c;
				font-size: 12px;
				padding-top: 4px;
			}
		}

		.el-input {
			.el-input__inner {
				border-radius: 4px;
			}
		}
	}

	// 分类详情模态框样式
	/deep/ .category-detail-content {
		.el-descriptions {
			&__title {
				color: #409EFF;
				font-weight: bold;
				margin-bottom: 10px;
			}

			&__item {
				padding: 8px 0;

				&__label {
					font-weight: 500;
					color: #606266;
				}

				&__content {
					color: #303133;
				}
			}
		}

		.category-rule-list {
			h4 {
				color: #409EFF;
				font-weight: bold;
				padding-bottom: 8px;
				border-bottom: 1px solid #e6e6e6;
			}

			.el-table {
				border-radius: 4px;
				overflow: hidden;
			}
		}
	}

	// 响应式设计
	@media (max-width: 1200px) {
		.box {
			.main {
				.main-left {
					width: 180px;
				}

				.main-right {
					.main-icon {
						flex-wrap: wrap;
						gap: 10px;

						.main-icon-c {
							margin: 5px 0;
						}
					}
				}
			}
		}
	}

	// 动画效果
	.el-button {
		transition: all 0.3s ease;

		&:hover {
			transform: translateY(-1px);
			box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
		}
	}

	.el-tree-node {
		transition: all 0.3s ease;

		&:hover {
			background-color: #f5f7fa;
		}
	}
	
	// 树节点高亮动画
	/deep/ .el-tree-node.is-current>.el-tree-node__content {
		transition: all 0.3s ease;
		animation: highlight-node 0.5s ease-in-out;
	}

	@keyframes highlight-node {
		0% {
			background-color: #fff;
		}

		50% {
			background-color: #ecf5ff;
			transform: scale(1.02);
		}

		100% {
			background-color: #ecf5ff;
		}
	}
</style>
<style lang="less">
/* 非scoped样式，全局生效但通过选择器限制范围 */
.box .main .main-left .el-tree.el-tree--highlight-current {
  .el-tree-node__content {
    padding-left: 0 !important;
  }
  
  .el-tree-node__children .el-tree-node__content {
    padding-left: 0 !important;
  }
}
</style>